import { EmailForm } from "components/programmatic/EmailForm";
import { ProgrammaticLogo } from "components/library/Logos";
import { useBreakpoints } from "hooks/useBreakpoints";

export const ProgrammaticHero = () => {
  const { isMediumWidth } = useBreakpoints();
  return (
    <div className="container-lg grid-12 mx-auto text-center selection:rounded selection:border selection:bg-blue-200">
      <div className="col-span-full text-center">
        <ProgrammaticLogo className="mx-auto h-[22px] md:h-28" />
        <h1 className="mt-40 font-display text-[40px] leading-[48px] md:text-[64px] md:leading-[88px]">
          Powerful{" "}
          {isMediumWidth ? (
            <span className="rounded-lg bg-blue-200 py-6 px-4">
              Weak Labeling
            </span>
          ) : (
            <>
              <span className="rounded-lg bg-blue-200 py-0 px-4 ">Weak</span>
              <br />
              <span className="rounded-lg bg-blue-200 py-0 px-4">Labeling</span>
            </>
          )}
          .
        </h1>
        <p className="mx-auto mt-24 mb-40 max-w-sm text-14-20 leading-[22px] text-gray-700 md:max-w-md md:text-20-32 ">
          Create large{" "}
          <span className="text-gray-900">high-quality datasets</span> for NLP
          in minutes. <span className="text-gray-900">No hand labeling</span>{" "}
          required.
        </p>
        <div className="mx-auto  mb-[92px] max-w-md md:max-w-lg">
          <EmailForm />
        </div>
      </div>
    </div>
  );
};
